export default "__VITE_ASSET__DkteAAh___"